// import { useState, useEffect, useRef } from "react";
// import { Link } from "react-router-dom";
// import { useTheme } from "../context/ThemeContext";
// import "./HomePage.css";

// const HomePage = () => {
//   const { theme } = useTheme();
//   const [activeFeature, setActiveFeature] = useState(0);
//   const [isVisible, setIsVisible] = useState(false);
//   const featuresRef = useRef([]);

//   useEffect(() => {
//     setIsVisible(true);
//     const interval = setInterval(() => {
//       setActiveFeature((prev) => (prev + 1) % features.length);
//     }, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   const features = [
//     {
//       icon: "📚",
//       title: "Comprehensive Notes",
//       description:
//         "Curated study materials covering all major topics with practical examples",
//       link: "/notes",
//     },
//     {
//       icon: "👨‍🏫",
//       title: "Expert Tutor",
//       description:
//         "Learn from Sanjay Singh with 15+ years of teaching experience",
//       link: "/contact",
//     },
//     {
//       icon: "💰",
//       title: "Affordable Pricing",
//       description:
//         "Quality education at competitive rates with flexible payment options",
//       link: "/fees",
//     },
//   ];

//   return (
//     <div className={`home-page ${theme} ${isVisible ? "visible" : ""}`}>

//       {/* Hero Section */}
//       <section className="hero">
//         <div className="hero-background">
//           <div className="floating-shapes">
//             <div className="shape shape-1"></div>
//             <div className="shape shape-2"></div>
//             <div className="shape shape-3"></div>
//           </div>
//         </div>

//         <div className="hero-content">
//           <div className="hero-text">
//             <h1 className="hero-title">
//               <span className="title-line">Welcome to</span>
//               <span className="title-main">
//                 <span className="gradient-text">EBI</span> Education
//               </span>
//             </h1>
//             <p className="hero-subtitle">
//               Where <span className="highlight">bright minds</span> meet{" "}
//               <span className="highlight">brighter futures</span>
//             </p>

//             <div className="hero-buttons">
//               <Link to="/courses" className="btn-link">
//                 <button className="btn btn-primary">
//                   <span>Explore Courses</span>
//                   <div className="btn-hover"></div>
//                 </button>
//               </Link>

//               <Link to="/contact" className="btn-link">
//                 <button className="btn btn-secondary">
//                   <span>Meet Our Tutor</span>
//                 </button>
//               </Link>
//             </div>
//           </div>

//           <div className="hero-visual">
//             <div className="animated-circles">
//               <div className="circle circle-1"></div>
//               <div className="circle circle-2"></div>
//               <div className="circle circle-3"></div>
//             </div>
//             <div className="floating-icons">
//               <div className="icon">📚</div>
//               <div className="icon">✏</div>
//               <div className="icon">🎓</div>
//               <div className="icon">⭐</div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Features Section */}
//       <section className="features-section">
//         <div className="container">
//           <div className="section-header">
//             <h2>Why Choose EBI?</h2>
//             <p>Our commitment to excellence in education</p>
//           </div>

//           <div className="features-grid">
//             {features.map((feature, index) => (
//               <Link to={feature.link} key={index} className="feature-card-link">
//                 <div
//                   ref={(el) => (featuresRef.current[index] = el)}
//                   className={`feature-card ${
//                     index === activeFeature ? "active" : ""
//                   }`}
//                   onMouseEnter={() => setActiveFeature(index)}
//                 >
//                   <div className="card-icon">{feature.icon}</div>
//                   <h3>{feature.title}</h3>
//                   <p>{feature.description}</p>
//                   <div className="card-overlay"></div>
//                 </div>
//               </Link>
//             ))}
//           </div>
//         </div>
//       </section>
//       {/* Quiz Section */}
//       <section className="quiz-section">
//         <div className="container">
//           <div className="section-header">
//             <h2>Test Your Knowledge</h2>
//             <p>Take our interactive quizzes to assess your understanding</p>
//           </div>

//           <div className="quiz-grid">
//             <div className="quiz-card">
//               <div className="quiz-icon">🧠</div>
//               <div className="quiz-content">
//                 <h3>Interactive Quizzes</h3>
//                 <p>
//                   Challenge yourself with our comprehensive quiz platform
//                   covering all subjects and topics
//                 </p>
//                 <ul className="quiz-features">
//                   <li>📊 Instant scoring & feedback</li>
//                   <li>⏱ Timed practice sessions</li>
//                   <li>📈 Progress tracking</li>
                  
//                 </ul>
//               </div>
//               <a
//                 href="https://quizzer-kohl.vercel.app/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="quiz-btn"
//               >
//                 <span>Enter Quiz Platform</span>
//                 <div className="quiz-btn-hover"></div>
//               </a>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Testimonials */}
//       <section className="testimonials-section">
//         <div className="container">
//           <div className="section-header">
//             <h2>Success Stories</h2>
//             <p>What our students say</p>
//           </div>

//           <div className="testimonials-grid">
//             <div className="testimonial-card">
//               <div className="testimonial-content">
//                 <div className="quote">
//                   "EBI's notes helped me score 95% in my finals!"
//                 </div>
//                 <div className="author">- Arshdeep Singh, Class 11</div>
//               </div>
//             </div>
//             <div className="testimonial-card">
//               <div className="testimonial-content">
//                 <div className="quote">
//                   "Sanjay Sir's teaching style made complex topics simple."
//                 </div>
//                 <div className="author">- Jasmeet Singh, (now in Canada)</div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Location Map */}
//       <section className="map-section">
//         <div className="container">
//           <div className="section-header">
//             <h2>Our Location</h2>
//             <p>Visit us for a personalized learning experience</p>
//           </div>
//           <div className="map-container">
//             <iframe
//               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1105.7559274491343!2d76.4763339!3d30.3715441!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390fd748b5c5e265%3A0x603542c711eb40af!2sEducation%20Bright%20Institute!5e0!3m2!1sen!2sin!4v1695746320000!5m2!1sen!2sin"
//               width="100%"
//               height="450"
//               style={{ border: 0 }}
//               allowFullScreen=""
//               loading="lazy"
//               referrerPolicy="no-referrer-when-downgrade"
//               title="Education Bright Institute Location"
//             ></iframe>
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="cta-section">
//         <div className="container">
//           <h2>Ready to Transform Your Learning?</h2>
//           <p>
//             Join EBI Education today and take the first step towards academic
//             excellence
//           </p>
//           <button className="cta-btn">
//             <span>Enroll Now</span>
//             <div className="cta-hover"></div>
//           </button>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default HomePage;
// import { useState, useEffect, useRef } from "react";
// import { Link } from "react-router-dom";
// import { useTheme } from "../context/ThemeContext";
// import "./HomePage.css";

// const HomePage = () => {
//   const { theme } = useTheme();
//   const [activeFeature, setActiveFeature] = useState(0);
//   const [isVisible, setIsVisible] = useState(false);
//   const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
//   const [scrollProgress, setScrollProgress] = useState(0);
//   const featuresRef = useRef([]);
//   const heroRef = useRef(null);
//   const titleRef = useRef(null);
//   const subtitleRef = useRef(null);

//   useEffect(() => {
//     setIsVisible(true);
//     const interval = setInterval(() => {
//       setActiveFeature((prev) => (prev + 1) % features.length);
//     }, 5000);

//     // Mouse move effect
//     const handleMouseMove = (e) => {
//       setMousePosition({
//         x: (e.clientX / window.innerWidth) * 100,
//         y: (e.clientY / window.innerHeight) * 100
//       });
//     };

//     // Scroll progress
//     const handleScroll = () => {
//       const scrollTop = window.scrollY;
//       const heroHeight = heroRef.current?.offsetHeight || 0;
//       const progress = Math.min((scrollTop / heroHeight) * 100, 100);
//       setScrollProgress(progress);
//     };

//     window.addEventListener('mousemove', handleMouseMove);
//     window.addEventListener('scroll', handleScroll);

//     // Text animation
//     const animateText = () => {
//       if (titleRef.current) {
//         titleRef.current.style.animation = 'none';
//         setTimeout(() => {
//           titleRef.current.style.animation = 'titleWave 2s ease-out';
//         }, 50);
//       }
//     };

//     const textInterval = setInterval(animateText, 4000);
//     animateText();

//     return () => {
//       clearInterval(interval);
//       clearInterval(textInterval);
//       window.removeEventListener('mousemove', handleMouseMove);
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, []);

//   const features = [
//     {
//       icon: "📚",
//       title: "Comprehensive Notes",
//       description: "Curated study materials covering all major topics with practical examples",
//       link: "/notes",
//     },
//     {
//       icon: "👨‍🏫",
//       title: "Expert Tutor",
//       description: "Learn from Sanjay Singh with 15+ years of teaching experience",
//       link: "/contact",
//     },
//     {
//       icon: "💰",
//       title: "Affordable Pricing",
//       description: "Quality education at competitive rates with flexible payment options",
//       link: "/fees",
//     },
//   ];

//   return (
//     <div className={`home-page ${theme} ${isVisible ? "visible" : ""}`}>

//       {/* Enhanced Hero Section */}
//       <section className="hero" ref={heroRef}>
//         {/* Advanced Background with Parallax */}
//         <div className="hero-background">
//           <div className="parallax-bg">
//             <div className="bg-layer layer-1" style={{ transform: `translate(${mousePosition.x * 0.02}px, ${mousePosition.y * 0.02}px)` }}></div>
//             <div className="bg-layer layer-2" style={{ transform: `translate(${mousePosition.x * 0.04}px, ${mousePosition.y * 0.04}px)` }}></div>
//             <div className="bg-layer layer-3" style={{ transform: `translate(${mousePosition.x * 0.06}px, ${mousePosition.y * 0.06}px)` }}></div>
//           </div>
          
//           {/* Animated Gradient Orbs */}
//           <div className="gradient-orbs">
//             <div className="orb orb-1" style={{ 
//               left: `${mousePosition.x * 0.1}%`,
//               top: `${mousePosition.y * 0.1}%`
//             }}></div>
//             <div className="orb orb-2" style={{ 
//               left: `${100 - mousePosition.x * 0.08}%`,
//               top: `${100 - mousePosition.y * 0.08}%`
//             }}></div>
//             <div className="orb orb-3" style={{ 
//               left: `${mousePosition.x * 0.12}%`,
//               top: `${100 - mousePosition.y * 0.12}%`
//             }}></div>
//           </div>

//           {/* Floating Particles */}
//           <div className="floating-particles-hero">
//             {[...Array(15)].map((_, i) => (
//               <div 
//                 key={i}
//                 className="particle-hero"
//                 style={{
//                   left: `${Math.random() * 100}%`,
//                   animationDelay: `${Math.random() * 5}s`,
//                   animationDuration: `${3 + Math.random() * 4}s`
//                 }}
//               ></div>
//             ))}
//           </div>

//           {/* Scroll Progress Indicator */}
//           <div className="scroll-progress" style={{ width: `${scrollProgress}%` }}></div>
//         </div>

//         <div className="hero-content">
//           <div className="hero-text">
//             {/* Animated Title */}
//             <h1 className="hero-title" ref={titleRef}>
//               <span className="title-line">Welcome to</span>
//               <span className="title-main">
//                 <span className="gradient-text">
//                   <span className="letter">E</span>
//                   <span className="letter">B</span>
//                   <span className="letter">I</span>
//                 </span>
//                 <span className="title-space"> </span>
//                 <span className="education-text">
//                   <span className="letter">E</span>
//                   <span className="letter">d</span>
//                   <span className="letter">u</span>
//                   <span className="letter">c</span>
//                   <span className="letter">a</span>
//                   <span className="letter">t</span>
//                   <span className="letter">i</span>
//                   <span className="letter">o</span>
//                   <span className="letter">n</span>
//                 </span>
//               </span>
//             </h1>

//             {/* Interactive Subtitle */}
//             <p className="hero-subtitle" ref={subtitleRef}>
//               Where <span className="highlight interactive-highlight">bright minds</span> meet{" "}
//               <span className="highlight interactive-highlight">brighter futures</span>
//             </p>

//             {/* Enhanced Buttons */}
//             <div className="hero-buttons">
//               <Link to="/courses" className="btn-link">
//                 <button className="btn btn-primary magnetic-btn">
//                   <span className="btn-text">Explore Courses</span>
//                   <div className="btn-hover"></div>
//                   <div className="btn-sparkle"></div>
//                 </button>
//               </Link>

//               <Link to="/contact" className="btn-link">
//                 <button className="btn btn-secondary magnetic-btn">
//                   <span className="btn-text">Meet Our Tutor</span>
//                   <div className="btn-dots"></div>
//                 </button>
//               </Link>
//             </div>
//           </div>

//           {/* Enhanced Visual Section */}
//           <div className="hero-visual">
//             {/* 3D Animated Sphere */}
//             <div className="animated-sphere">
//               <div className="sphere-core"></div>
//               <div className="sphere-ring ring-1"></div>
//               <div className="sphere-ring ring-2"></div>
//               <div className="sphere-ring ring-3"></div>
//               <div className="sphere-glow"></div>
//             </div>

//             {/* Orbiting Elements */}
//             <div className="orbiting-elements">
//               <div className="orbit orbit-1">
//                 <div className="orbiting-icon">📚</div>
//               </div>
//               <div className="orbit orbit-2">
//                 <div className="orbiting-icon">🎓</div>
//               </div>
//               <div className="orbit orbit-3">
//                 <div className="orbiting-icon">⭐</div>
//               </div>
//             </div>

//             {/* Floating Cards */}
//             {/* <div className="floating-cards">
//               <div className="floating-card card-1">
//                 <div className="card-content">15+ Years Experience</div>
//               </div>
//               <div className="floating-card card-2">
//                 <div className="card-content">95% Success Rate</div>
//               </div>
//               <div className="floating-card card-3">
//                 <div className="card-content">Expert Guidance</div>
//               </div>
//             </div> */}
//           </div>
//         </div>

//         {/* Scroll Indicator */}
//         {/* <div className="scroll-indicator">
//           <div className="scroll-arrow">
//             <div className="scroll-arrow-inner"></div>
//           </div>
//           <span>Scroll to explore</span>
//         </div> */}
//       </section>

//       {/* Features Section */}
//       <section className="features-section">
//         <div className="container">
//           <div className="section-header">
//             <h2>Why Choose EBI?</h2>
//             <p>Our commitment to excellence in education</p>
//           </div>

//           <div className="features-grid">
//             {features.map((feature, index) => (
//               <Link to={feature.link} key={index} className="feature-card-link">
//                 <div
//                   ref={(el) => (featuresRef.current[index] = el)}
//                   className={`feature-card ${
//                     index === activeFeature ? "active" : ""
//                   }`}
//                   onMouseEnter={() => setActiveFeature(index)}
//                 >
//                   <div className="card-icon">{feature.icon}</div>
//                   <h3>{feature.title}</h3>
//                   <p>{feature.description}</p>
//                   <div className="card-overlay"></div>
//                 </div>
//               </Link>
//             ))}
//           </div>
//         </div>
//       </section>
//       {/* Quiz Section */}
//       <section className="quiz-section">
//         <div className="container">
//           <div className="section-header">
//             <h2>Test Your Knowledge</h2>
//             <p>Take our interactive quizzes to assess your understanding</p>
//           </div>

//           <div className="quiz-grid">
//             <div className="quiz-card">
//               <div className="quiz-icon">🧠</div>
//               <div className="quiz-content">
//                 <h3>Interactive Quizzes</h3>
//                 <p>
//                   Challenge yourself with our comprehensive quiz platform
//                   covering all subjects and topics
//                 </p>
//                 <ul className="quiz-features">
//                   <li>📊 Instant scoring & feedback</li>
//                   <li>⏱ Timed practice sessions</li>
//                   <li>📈 Progress tracking</li>
                  
//                 </ul>
//               </div>
//               <a
//                 href="https://quizzer-kohl.vercel.app/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="quiz-btn"
//               >
//                 <span>Enter Quiz Platform</span>
//                 <div className="quiz-btn-hover"></div>
//               </a>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Testimonials */}
//       <section className="testimonials-section">
//         <div className="container">
//           <div className="section-header">
//             <h2>Success Stories</h2>
//             <p>What our students say</p>
//           </div>

//           <div className="testimonials-grid">
//             <div className="testimonial-card">
//               <div className="testimonial-content">
//                 <div className="quote">
//                   "EBI's notes helped me score 95% in my finals!"
//                 </div>
//                 <div className="author">- Arshdeep Singh, Class 11</div>
//               </div>
//             </div>
//             <div className="testimonial-card">
//               <div className="testimonial-content">
//                 <div className="quote">
//                   "Sanjay Sir's teaching style made complex topics simple."
//                 </div>
//                 <div className="author">- Jasmeet Singh, (now in Canada)</div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Location Map */}
//       <section className="map-section">
//         <div className="container">
//           <div className="section-header">
//             <h2>Our Location</h2>
//             <p>Visit us for a personalized learning experience</p>
//           </div>
//           <div className="map-container">
//             <iframe
//               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1105.7559274491343!2d76.4763339!3d30.3715441!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390fd748b5c5e265%3A0x603542c711eb40af!2sEducation%20Bright%20Institute!5e0!3m2!1sen!2sin!4v1695746320000!5m2!1sen!2sin"
//               width="100%"
//               height="450"
//               style={{ border: 0 }}
//               allowFullScreen=""
//               loading="lazy"
//               referrerPolicy="no-referrer-when-downgrade"
//               title="Education Bright Institute Location"
//             ></iframe>
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="cta-section">
//         <div className="container">
//           <h2>Ready to Transform Your Learning?</h2>
//           <p>
//             Join EBI Education today and take the first step towards academic
//             excellence
//           </p>
//           <button className="cta-btn">
//             <span>Enroll Now</span>
//             <div className="cta-hover"></div>
//           </button>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default HomePage;
import { useTheme } from "../context/ThemeContext";
import { Link } from "react-router-dom";
import "./HomePage.css";

const features = [
  {
    icon: "📚",
    title: "Comprehensive Notes",
    description: "Curated study materials covering all major topics with practical examples",
    link: "/notes",
  },
  {
    icon: "👨‍🏫",
    title: "Expert Tutor",
    description: "Learn from Sanjay Singh with 15+ years of teaching experience",
    link: "/about",
  },
  {
    icon: "💰",
    title: "Affordable Pricing",
    description: "Quality education at competitive rates with flexible payment options",
    link: "/fees",
  },
];

export default function HomePage() {
  const { theme } = useTheme();

  return (
    <div className="ebi-homepage-pro" data-theme={theme}>
      {/* Hero Section */}
      <section className="ebi-hero-pro">
        {/* Animated Grid Background */}
        <div className="hero-grid-bg">
          <div className="grid-lines"></div>
          <div 
            className="gradient-spotlight"
            style={{
              background: `radial-gradient(circle at 50% 50%, rgba(59, 130, 246, 0.15) 0%, transparent 50%)`
            }}
          ></div>
        </div>

        {/* Geometric Shapes */}
        <div className="geometric-shapes">
          <div className="shape-hexagon hex-1"></div>
          <div className="shape-hexagon hex-2"></div>
          <div className="shape-cube cube-1"></div>
          <div className="shape-cube cube-2"></div>
          <div className="shape-ring ring-1"></div>
          <div className="shape-ring ring-2"></div>
        </div>

        {/* Floating Particles */}
        <div className="particles-container">
          {[...Array(30).keys()].map(i => (
            <div
              className="tech-particle"
              key={i}
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 4}s`,
                animationDuration: `${4 + Math.random() * 3}s`
              }}
            />
          ))}
        </div>

        {/* Hero Content */}
        <div className="hero-content-pro">
          <div className="hero-left-pro">
            <h1 className="hero-title-pro">
              <span className="title-welcome">Welcome to</span>
              <span className="title-brand">
                <span className="brand-ebi">EBI</span>
                <span className="brand-education">Education</span>
              </span>
            </h1>
            <p className="hero-desc-pro">
              Where <span className="text-highlight">bright minds</span> meet{" "}
              <span className="text-highlight">brighter futures</span>
            </p>
            <div className="hero-actions-pro">
              <Link to="/courses">
                <button className="btn-pro btn-primary-pro">
                  <span>Explore Courses</span>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </Link>
              <Link to="/contact">
                <button className="btn-pro btn-secondary-pro">
                  <span>Meet Our Tutor</span>
                </button>
              </Link>
            </div>
          </div>

          <div className="hero-right-pro">
            <div className="visual-container">
              {/* 3D Cube Animation */}
              <div className="cube-3d">
                <div className="cube-face front">📚</div>
                <div className="cube-face back">🎓</div>
                <div className="cube-face right">⭐</div>
                <div className="cube-face left">✏️</div>
                <div className="cube-face top">💡</div>
                <div className="cube-face bottom">🏆</div>
              </div>
              
              {/* Orbiting Elements */}
              <div className="orbit-system">
                <div className="orbit orbit-1">
                  <div className="orbit-dot"></div>
                </div>
                <div className="orbit orbit-2">
                  <div className="orbit-dot"></div>
                </div>
                <div className="orbit orbit-3">
                  <div className="orbit-dot"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="section-pro features-section-pro">
        <div className="container-pro">
          <div className="section-header-pro">
            <span className="section-tag">Our Strengths</span>
            <h2>Why Choose EBI?</h2>
            <p>Experience excellence in education with our proven methodology</p>
          </div>
          <div className="features-grid-pro">
            {features.map((feature, idx) => (
              <Link to={feature.link} key={idx} className="feature-link-pro">
                <div className="feature-card-pro">
                  <div className="feature-icon-pro">{feature.icon}</div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                  <div className="card-shine"></div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Quiz Section */}
      <section className="section-pro quiz-section-pro">
        <div className="container-pro">
          <div className="section-header-pro">
            <span className="section-tag">Interactive Learning</span>
            <h2>Test Your Knowledge</h2>
          </div>
          <div className="quiz-container-pro">
            <div className="quiz-icon-large">🧠</div>
            <h3>Interactive Quiz Platform</h3>
            <p>Challenge yourself with our comprehensive quiz system</p>
            <ul className="quiz-features-pro">
              <li><span>📊</span> Instant scoring & detailed feedback</li>
              <li><span>⏱</span> Timed practice sessions</li>
              <li><span>📈</span> Progress tracking & analytics</li>
            </ul>
            <a 
              href="https://quizzer-kohl.vercel.app/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-pro btn-primary-pro quiz-btn-pro"
            >
              <span>Launch Quiz Platform</span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="section-pro testimonials-section-pro">
        <div className="container-pro">
          <div className="section-header-pro">
            <span className="section-tag">Success Stories</span>
            <h2>What Our Students Say</h2>
          </div>
          <div className="testimonials-grid-pro">
            <div className="testimonial-card-pro">
              <div className="quote-icon">"</div>
              <p className="testimonial-text">
                The notes are so well-organized that revision became a breeze before exams. Saved me countless hours!
              </p>
              <div className="testimonial-author">
                <strong>Karanjot Singh</strong>
                <span>Chappar </span>
              </div>
            </div>
            <div className="testimonial-card-pro">
              <div className="quote-icon">"</div>
              <p className="testimonial-text">
                Sanjay Sir's teaching style made complex topics simple.
              </p>
              <div className="testimonial-author">
                <strong>Jasmeet Singh</strong>
                <span>Now in Canada</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Location Map */}
      <section className="section-pro map-section-pro">
        <div className="container-pro">
          <div className="section-header-pro">
            <span className="section-tag">Visit Us</span>
            <h2>Our Location</h2>
            <p>Come visit us for a personalized learning experience</p>
          </div>
          <div className="map-wrapper-pro">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1105.7559274491343!2d76.4763339!3d30.3715441!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390fd748b5c5e265%3A0x603542c711eb40af!2sEducation%20Bright%20Institute!5e0!3m2!1sen!2sin!4v1695746320000!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Education Bright Institute Location"
            ></iframe>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-pro cta-section-pro">
        <div className="container-pro">
          <div className="cta-content-pro">
            <h2>Ready to Transform Your Learning?</h2>
            <p>Join EBI Education today and take the first step towards academic excellence</p>
            <button className="btn-pro btn-primary-pro btn-large-pro">
              <span>Enroll Now</span>
              <svg width="24" height="24" viewBox="0 0 20 20" fill="none">
                <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}